"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _excluded = ["blockProps", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  var component = WrappedComponent.WrappedComponent || WrappedComponent;
  return component.displayName || component.name || 'Component';
};

var _default = function _default(_ref) {
  var store = _ref.store;
  return function (WrappedComponent) {
    var _class;

    return _class = /*#__PURE__*/function (_Component) {
      _inheritsLoose(BlockAlignmentDecorator, _Component);

      function BlockAlignmentDecorator() {
        var _this;

        _this = _Component.call(this) || this;

        _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
          if (nextProps.style.width !== _this.props.style.width) {
            _this.widthShouldGetFromBlockProps = false;
          }
        });

        _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
          if (_this.props.blockProps.isFocused && _this.props.blockProps.isCollapsedSelection) {
            // TODO figure out if and how to achieve this without fetching the DOM node
            // eslint-disable-next-line react/no-find-dom-node
            var blockNode = _reactDom["default"].findDOMNode(_assertThisInitialized(_this));

            var boundingRect = blockNode.getBoundingClientRect();
            store.updateItem('updateData', _this.props.blockProps.updateData);
            store.updateItem('alignment', _this.props.blockProps.alignment);
            store.updateItem('boundingRect', boundingRect);
            store.updateItem('visibleBlock', _this.props.block.getKey()); // Only set visibleBlock to null in case it's the current one. This is important
            // in case the focus directly switches from one block to the other. Then the
            // Alignment tool should not be hidden, but just moved.
          } else if (store.getItem('visibleBlock') === _this.props.block.getKey()) {
            store.updateItem('visibleBlock', null);
          }
        });

        _this.widthShouldGetFromBlockProps = false;
        return _this;
      }

      var _proto = BlockAlignmentDecorator.prototype;

      _proto.componentWillMount = function componentWillMount() {
        store.subscribeToItem('width', this.onWidthChangeFromToolbar.bind(this));
      };

      _proto.onWidthChangeFromToolbar = function onWidthChangeFromToolbar(width) {
        this.widthShouldGetFromBlockProps = true;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Set visibleBlock to null if the block is deleted
        store.updateItem('visibleBlock', null);
        store.unsubscribeFromItem('width', this.onWidthChangeFromToolbar.bind(this));
      };

      _proto.render = function render() {
        var _this$props = this.props,
            blockProps = _this$props.blockProps,
            style = _this$props.style,
            elementProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

        var alignment = blockProps.alignment;
        var newStyle = style;

        if (alignment === 'left') {
          newStyle = _extends({}, style, {
            marginRight: 'auto'
          });
        } else if (alignment === 'right') {
          newStyle = _extends({}, style, {
            marginLeft: 'auto'
          });
        } else if (alignment === 'center') {
          newStyle = _extends({}, style, {
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block'
          });
        }

        if (this.widthShouldGetFromBlockProps) {
          newStyle.width = blockProps.width + "%";
        }

        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, elementProps, {
          blockProps: blockProps,
          style: newStyle
        }));
      };

      return BlockAlignmentDecorator;
    }(_react.Component), _defineProperty(_class, "displayName", "BlockDraggable(" + getDisplayName(WrappedComponent) + ")"), _defineProperty(_class, "WrappedComponent", WrappedComponent.WrappedComponent || WrappedComponent), _class;
  };
};

exports["default"] = _default;
module.exports = exports.default;